import * as React from 'react';
import { connect } from 'react-redux';
import {
  Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem, } from 'reactstrap';
import { Link } from 'react-router-dom';
import { UserState } from '../store/User';
import { ApplicationState } from '../store';
import './NavMenu.css';
import HCSLogo from '../images/hcs-logo-horiz-no-text.svg';

type NavMenuProps =
  UserState;

//Alias the window propert so we do not have issues with using window.config that typescript doesn't recognize.
const windowAlias: any = window;

class NavMenu extends React.PureComponent<NavMenuProps, { isOpen: boolean }> {
  public state = {
    isOpen: false
  };

  public render() {
    if (!this.props.user) return null;
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm border-bottom box-shadow mb-3 navbar-hcs" light>
          <Container>
            <NavbarBrand tag={Link} to="/"><img src={HCSLogo} alt="HealthcareSource" /></NavbarBrand>
            <NavbarToggler onClick={this.toggle} className="mr-2" />
            <Collapse className="d-sm-inline-flex" isOpen={this.state.isOpen} navbar>
              {windowAlias.config.options.redirectUrl && windowAlias.config.options.redirectText && (
                <Nav className="navbar-nav flex-grow ml-0">
                  <NavItem>
                    <NavLink href={windowAlias.config.options.redirectUrl}><i className="fas fa-arrow-circle-left"/> {windowAlias.config.options.redirectText}</NavLink>
                  </NavItem>
                </Nav>
              )}
              <Nav className="navbar-nav flex-grow ml-auto">
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Welcome, {this.props.user.profile.given_name}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <NavLink tag={Link} className="text-dark" to="/">Profile</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink tag={Link} className="text-dark" to="/documents">Documents</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink tag={Link} className="text-dark" to="/logout">Log Out</NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }

  private toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
}

export default connect(
  (state: ApplicationState) => state.user,
)(NavMenu);
